import './App.css';
import React, { useState, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import StripePaymentsLink from './StripePaymentsLink';
import PaymentSuccess from './PaymentSuccess';
import AuthorizeNet from './AuthorizeNet';
import Helcim from './Helcim';
import WebpageCheckOut from './WebpageCheckout';
import AuthorizeSubscription from './AuthorizeSubscription';
import StripeSubscription from './StripeSubscription';
import StripeChangeCard from './StripeChangeCard';
import ChangeStripeCardUser from './ChangeStripeCardUser';
import AuthorizeCardChange from './AuthorizeCardChange';
import AuthorizeCardChangeUser from './AuthorizeCardChangeUser';
import HelcimSubscription from './HelcimSubscription';
import Gravity from './Gravity';
import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_URL;
export const config = {
  Accept: 'application/json',
  headers: {
    // Authorization: `Bearer ${token}`,
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
};
function App() {

  useEffect(() => {
    handleFetchDomainDetails();
  }, []);

  const handleFetchDomainDetails = async () => {
    const hostId = window.location.host.split('.').slice(-2).join('.');
    const res = await axios.get(`${baseURL}/internal/accounts/fetch-hosts/${hostId}`, config);
    if (res?.data?.status === 'success') {
      const domainDetails = res?.data?.data[0];
      if (domainDetails) {
        localStorage.setItem('h_name', domainDetails?.name);
        localStorage.setItem('h_url', domainDetails?.logo);
        document.title = domainDetails?.name;
        const newLink = document.createElement('link');
        newLink.rel = 'icon';
        newLink.href = domainDetails?.logo;
        document.head.appendChild(newLink);
      } else {
        localStorage.removeItem('h_name');
        localStorage.removeItem('h_url');
        document.title = 'SalesCaptain';
        const newLink = document.createElement('link');
        newLink.rel = 'icon';
        newLink.href = 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2024-10-15/webchat_1728990607600.png';
        document.head.appendChild(newLink);
      }
    }
  };

  return (
    <div>
      <Routes>
        <Route path="/stripe-payments/:id" element={<StripePaymentsLink />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/authorizenet/:cid/:id" element={<AuthorizeNet />} />
        <Route path="/helcim/:cid/:id" element={<Helcim />} />
        <Route path="/gravity/:cid/:id" element={<Gravity />} />
        <Route path="/sc-pay/checkout/:cid" element={<WebpageCheckOut />} />
        <Route path="/authorizenet/Subscriptions/:id" element={<AuthorizeSubscription />} />
        <Route path="/stripe/Subscriptions/:id/:aid" element={<StripeSubscription />} />
        <Route path="/stripe/updatecard/:id/:aid/:cid/:sid/:mail" element={<StripeChangeCard />} />
        <Route path="/stripe/updatecard/user/:id/:aid/:cid/:sid/:mail" element={<ChangeStripeCardUser />} />
        <Route path="/authorize/updatecard/:id/:cid/:sid" element={<AuthorizeCardChange />} />
        <Route path="/authorize/updatecard/user/:id/:cid/:sid" element={<AuthorizeCardChangeUser />} />
        <Route path="/helcim/subscription/:cid/:contId/:sid" element={<HelcimSubscription />} />
      </Routes>
    </div>
  );
}

export default App;
